export const DATA_URL_REGEX = /^data:(?<mimeType>[^;,]+)?(?<base64>;base64)?,(?<data>.*)$/;

/**
 * Safely parse a url string into a URL object.
 * It returns null if the url is invalid.
 */
export function parseUrl(input: string): URL | null {
    try {
        const url = new URL(input);
        return url;
    } catch (_err) {
        return null;
    }
}

interface DataURL {
    mimeType?: string;
    isBase64: boolean;
    data: Blob;
}

/**
 * Parse a data url string into an object that includes the decoded data.
 */
export function parseDataUrl(input: string): DataURL | null {
    const match = input.match(DATA_URL_REGEX);

    if (!match || !match.groups) {
        return null;
    }

    const { mimeType, base64, data: encodedData } = match.groups;

    if (!encodedData) {
        return null;
    }

    const isBase64 = Boolean(base64);
    const blobOptions = mimeType ? { type: mimeType } : undefined;

    if (isBase64) {
        const binaryString = atob(encodedData);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        return {
            mimeType,
            isBase64,
            data: new Blob([bytes], blobOptions),
        };
    }

    const text = decodeURIComponent(encodedData);
    return {
        mimeType,
        isBase64,
        data: new Blob([text], blobOptions),
    };
}
